import { Link } from '../../../../../../Resource/Types';
import { CollaboratorAccessResource, Draft } from '../Types';

interface Closed {
  kind: 'closed';
}

interface Loading {
  kind: 'loading';
  link: Link;
}

interface Ready {
  kind: 'ready';
  resource: CollaboratorAccessResource;
  draft: Draft;
}

interface Saving {
  kind: 'saving';
  resource: CollaboratorAccessResource;
  draft: Draft;
}

// The save request failed; the form stays open with the draft intact so the
// admin can adjust and retry.
interface SaveFailed {
  kind: 'save-failed';
  resource: CollaboratorAccessResource;
  draft: Draft;
}

// Transient: the container refreshes the list and closes immediately, so no
// confirmation is ever rendered.
interface Saved {
  kind: 'saved';
}

// The initial load failed; there is nothing to edit.
interface LoadFailed {
  kind: 'load-failed';
}

export type State = Closed | Loading | Ready | Saving | SaveFailed | Saved | LoadFailed;

export type EditingState = Ready | Saving | SaveFailed;

export type OpenState = Exclude<State, Closed | Saved>;

export const closed = (): Closed => ({ kind: 'closed' });

export const loading = (link: Link): Loading => ({ kind: 'loading', link });

export const ready = (resource: CollaboratorAccessResource, draft: Draft): Ready => ({
  kind: 'ready',
  resource,
  draft,
});

export const saving = (resource: CollaboratorAccessResource, draft: Draft): Saving => ({
  kind: 'saving',
  resource,
  draft,
});

export const saveFailed = (resource: CollaboratorAccessResource, draft: Draft): SaveFailed => ({
  kind: 'save-failed',
  resource,
  draft,
});

export const saved = (): Saved => ({ kind: 'saved' });

export const loadFailed = (): LoadFailed => ({ kind: 'load-failed' });
